module.exports = __webpack_public_path__ + "img/starlit-edge-logo.6313e1b8.png";